module.exports = __webpack_public_path__ + "img/icon_422A8423_2048px.23637740.jpg";